<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-else>
            <div style="padding-bottom: 50px">
                <div v-for="(cmpt, i) in itemsList" :key="i"
                     style="font-size: 15px; text-align: left;margin-bottom: 5px">
                    <createCompnents :cmpt="cmpt" :key="cmpt.componentName+'-'+i"
                                     :extra="{parentIndex : i}"></createCompnents>
                </div>
                <div style="height: 5px"></div>
                <van-field
                    v-model="optionMind"
                    placeholder="审批意见"
                    type="textarea"/>
            </div>

            <div class="m-l-12 m-r-12" style="position: fixed; bottom: 12px; left: 0px; right: 0px; ">
                <van-button
                    style="background-color: #3388ff; color: white; width: 100%" @click.native="commit">确定
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import indicatorEmpty from './empty';
    import createCompnents from './createCompnents';

    export default {
        components: {
            createCompnents,
            indicatorEmpty
        },
        name: 'approve-commit',
        mixins: [head],
        data() {
            return {
                indicatorType: 0,
                optionMind: '',
                itemsList: []
            };
        },
        props: {},
        watch: {},
        computed: {},
        created() {
            window.moreButton({});
            this.init();
        },
        mounted() {
            window.returnValue = (vals, extra) => {
                this.returnValue(vals, extra);
            };

            window.pickRelate = (availableTemplates, extra) => {
                window.tempRelate = {
                    availableTemplates: availableTemplates,
                    extra: extra
                };
                this.PUSH({ name: 'approve-choice', query: {} });
            };
        },
        methods: {

            init() {
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                    if (!_.isEmpty(window.tempRelate) && !_.isEmpty(window.tempRelate.data)) {
                        let tempRelate = _.cloneDeep(window.tempRelate.data);
                        let extra = _.cloneDeep(window.tempRelate.extra);
                        window.tempRelate = {};
                        this.returnValue(JSON.stringify(tempRelate), JSON.stringify(extra));
                    }
                } else {
                    if (window.tempForm) {
                        let tempForm = JSON.parse(window.tempForm.temp.form);
                        this.initFrom(tempForm);
                    }
                }
            },

            initFrom(table) {
                for (let i = 0; i < table.length; i++) {
                    let cmpt = table[i];
                    let valueData;
                    try {
                        valueData = this.detailData[cmpt.props.id];
                    } catch (e) {
                        console.log('initData', e);
                    }
                    if (cmpt.componentName == 'TableField') {
                        let children = _.cloneDeep(cmpt.children);
                        cmpt.children = [];
                        if (valueData && valueData.length > 0) {
                            for (let j = 0; j < valueData.length; j++) {
                                let temp = [];
                                this.initValue(temp, _.cloneDeep(children), valueData[j]);
                                cmpt.children.push(temp);
                            }
                        } else {
                            let temp = [];
                            this.initValue(temp, _.cloneDeep(children), null);
                            cmpt.children.push(temp);
                        }
                        this.itemsList.push(cmpt);
                    } else {
                        this.initValueSingle(cmpt, valueData);
                        this.itemsList.push(cmpt);
                    }
                }
            },

            /**
             * 遍历控件添加到监听数据
             * dataList 目的表单
             * tableList 要添加的表单
             * valueList 值
             **/
            initValue(dataList, tableList, valueList) {
                for (let i = 0; i < tableList.length; i++) {
                    let cmpt = tableList[i];
                    let valueData = null;
                    try {
                        valueData = valueList[cmpt.props.id];
                    } catch (e) {
                        console.log('initValue', e);
                    }
                    this.initValueSingle(cmpt, valueData);
                    dataList.push(cmpt);
                }
            },

            initValueSingle(cmpt, valueData) {
                if (cmpt.componentName == 'TableField') {
                } else {
                    if (valueData) {
                        if (cmpt.componentName == 'RelateField') {
                            for (let i = 0; i < valueData.length; i++) {
                                if (!valueData[i].statusCd) {
                                    valueData[i].statusCd = '';
                                }
                            }
                            cmpt.value = valueData;
                        } else {
                            cmpt.value = valueData;
                        }
                    } else {
                        if (cmpt.componentName == 'TextField' || cmpt.componentName == 'NumberField' || cmpt.componentName == 'TextareaField' || cmpt.componentName == 'SelectField' || cmpt.componentName == 'MoneyField') {
                            cmpt.value = '';
                        } else if (cmpt.componentName == 'DateField') {
                            cmpt.value = '';
                        } else if (cmpt.componentName == 'TimeAndLocationField') {
                            cmpt.value = { address: '' };
                        } else if (cmpt.componentName == 'DateRangeField') {
                            cmpt.value = ['', '', ''];
                        } else {
                            cmpt.value = [];
                        }
                    }
                }
            },

            /**
             * js调原生后返回数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            returnValue(val, extra) {
                console.log('returnValue', val, extra);
                let extraData = JSON.parse(extra);
                if (extraData.returnType == 'pickImage' || extraData.returnType == 'pickAttach') {
                    this.addArrayValue(JSON.parse(val), JSON.parse(extra));
                } else if (extraData.returnType == 'pickCustomer' || extraData.returnType == 'pickDep') {
                    this.setArrayValue(val, extra);
                } else if (extraData.returnType == 'pickLocation') {
                    let newVal = JSON.parse(val);
                    newVal.time = new Date();
                    this.setValue(newVal, extraData);
                } else if (extraData.returnType == 'pickUser') {
                    if (extraData.parentIndex != null) {
                        this.setArrayValue(val, extra);
                    } else if (extraData.processIndex != null) {
                        let user = JSON.parse(val);
                        let preIndex = extraData.processIndex - 1;
                        if (preIndex >= 0) {
                            if (this.processList[preIndex].approvals.length == 1 && user.length == 1 && user[0].profileId == this.processList[preIndex].approvals[0]) {
                                this.$toast({
                                    forbidClick: true,
                                    message: '该审批人已存在',
                                    duration: 1000
                                });
                                return;
                            }
                        }
                        this.setProcessValue(val, extra);
                    } else if (extraData.notifierIndex != null) {
                        let profileIds = this.updateUserDetails(JSON.parse(val));
                        let alreadyExist = false;
                        for (let i = 0; i < profileIds.length; i++) {
                            let needAdd = true;
                            for (let j = 0; j < this.notifierList.length; j++) {
                                if (profileIds[i] == this.notifierList[j].value) {
                                    alreadyExist = true;
                                    needAdd = false;
                                    break;
                                }
                            }
                            if (needAdd) {
                                this.notifierList.splice(extraData.notifierIndex, 0, {
                                    type: 'user',
                                    value: profileIds[i],
                                    canDelete: true
                                });
                            }
                        }
                        if (alreadyExist) {
                            this.$toast({
                                forbidClick: true,
                                message: '该抄送人已存在',
                                duration: 1000
                            });
                        }
                    }
                } else if (extraData.returnType == 'pickRole') {
                    if (extraData.processIndex != null) {
                        let ids = this.updateUserDetails(JSON.parse(val));
                        let rule = this.processList[extraData.processIndex];
                        if (rule.approvals) {
                            rule.approvals.splice(0, rule.approvals.length, ...ids);
                        } else {
                            rule.approvals = ids;
                        }
                    }
                } else if (extraData.returnType == 'pickDate') {
                    let newVal = moment(val).format('YYYY-MM-DD');
                    if (extraData.range != null) {
                        this.setValueRange(newVal, extraData, extraData.range);
                    } else {
                        this.setValue(newVal, extraData);
                    }
                } else if (extraData.returnType == 'pickTime') {
                    let newVal = moment(val).format('YYYY-MM-DD HH:mm');
                    if (extraData.range != null) {
                        this.setValueRange(newVal, extraData, extraData.range);
                    } else {
                        this.setValue(newVal, extraData);
                    }
                } else if (extraData.returnType == 'pickSingle') {
                    let newVal = JSON.parse(val).text;
                    this.setValue(newVal, extraData);
                }
            },

            /**
             * 在原有数组数据上叠加
             * @param val
             * @param extra js调原生时传过去的值
             */
            addArrayValue(val, extra) {
                console.log('addArrayValue', this.itemsList);
                let value;
                if (extra.childTableIndex == null) {
                    console.log('no-table');
                    value = this.itemsList[extra.parentIndex].value;
                } else {
                    console.log('yes-table');
                    value = this.itemsList[extra.parentIndex].children[extra.childTableIndex][extra.childIndexInTable].value;
                }
                value.splice(value.length, 0, ...val);
            },


            /**
             * 替换原有数组数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            setArrayValue(val, extra) {
                let extraData = JSON.parse(extra);
                let parentIndex = extraData.parentIndex;
                let tableIndex = extraData.childTableIndex;
                let childIndexInTable = extraData.childIndexInTable;
                let value;
                if (tableIndex == null) {
                    value = this.itemsList[parentIndex].value;
                } else {
                    value = this.itemsList[parentIndex].children[tableIndex][childIndexInTable].value;
                }
                value.splice(0, value.length, ...JSON.parse(val));
            },

            /**
             * 替换原有对象数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            setValue(val, extra) {
                let parentIndex = extra.parentIndex;
                let tableIndex = extra.childTableIndex;
                let childIndexInTable = extra.childIndexInTable;
                if (tableIndex == null) {
                    this.itemsList[parentIndex].value = val;
                } else {
                    this.itemsList[parentIndex].children[tableIndex][childIndexInTable].value = val;
                }
            },

            /**
             * 替换原有对象数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            setValueRange(val, extra, range) {
                let parentIndex = extra.parentIndex;
                let tableIndex = extra.childTableIndex;
                let childIndexInTable = extra.childIndexInTable;
                if (tableIndex == null) {
                    this.itemsList[parentIndex].value.splice(range, 1, val);
                } else {
                    this.itemsList[parentIndex].children[tableIndex][childIndexInTable].value.splice(range, 1, val);
                }
            },

            onResult(parentIndex, tableIndex, childIndexInTable, cmpt) {
                console.log('onResult', parentIndex, tableIndex, childIndexInTable, cmpt);
                if (tableIndex == null) {
                    this.itemsList.splice(parentIndex, 1, cmpt);
                } else {
                    this.itemsList[parentIndex].children[tableIndex].splice(childIndexInTable, 1, cmpt);
                }

                //条件审批判断
                if (tableIndex == null) { //明细不为判断组件
                    let changed = false;
                    for (let key in this.condition) {
                        if (key == cmpt.props.id) {
                            let value = '';
                            if (cmpt.componentName == 'DateRangeField') {
                                if (cmpt.value[0] && cmpt.value[1]) {
                                    let start = moment(cmpt.value[0]);
                                    let end = moment(cmpt.value[1]);
                                    if (cmpt.props.unit == '天') {
                                        value = end.diff(start, 'day') + 1;
                                    } else if (cmpt.props.unit == '小时') {
                                        value = end.diff(start, 'hour');
                                    }
                                }
                            } else if (cmpt.componentName == 'SelectField') {
                                value = cmpt.value;
                            } else if (cmpt.componentName == 'HrField') {
                                if (cmpt.value && cmpt.value.length > 0) {
                                    value = cmpt.value[0].profileId;
                                }
                            } else if (cmpt.componentName == 'NumberField') {
                                value = cmpt.value;
                            } else if (cmpt.componentName == 'MoneyField') {
                                value = cmpt.value;
                            } else {
                                value = cmpt.value;
                            }
                            console.log(key, cmpt);
                            if (this.condition[key] != value) {
                                changed = true;
                                this.condition[key] = value;
                            }
                            break;
                        }
                    }
                    if (changed) {
                        this.getProcess(this.condition);
                    }
                }
            },

            commit() {

            }
        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';
</style>
